import { Subject } from 'rxjs';

export class GasTabsHelper {
  static changeTabsStateSubject$: Subject<boolean> = new Subject();
}
